import { AccountInformation } from "@cpchem/azure-auth";
import { createContext } from "react";

export interface AuthContextProps {
    currentAccount: AccountInformation | null;
    isLoggedIn: boolean;
    login: () => void;
    logout: () => void;
}

export const AuthContext = createContext<AuthContextProps>({
    currentAccount: null,
    isLoggedIn: false,
    login: () => {},
    logout: () => {}
});
